module.exports = __webpack_public_path__ + "img/16m005-09.0c989017.jpg";